import Vuex from 'vuex';

Vue.use(Vuex);

window.Vuex = Vuex;
window.vuexStore = new Vuex.Store();
